import { render, staticRenderFns } from "./mortgage-update-details.vue?vue&type=template&id=6b974855"
import script from "./mortgage-update-details.vue?vue&type=script&lang=ts"
export * from "./mortgage-update-details.vue?vue&type=script&lang=ts"
import style0 from "./mortgage-update-details.vue?vue&type=style&index=0&id=6b974855&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VForm,VSelect})
